<template>
  <div>
    <div class="display-flex align-center mb-2">
      <div class="mr-2 text-center" style="flex: 0 0 24px;">
        <v-icon color="primary" small>fas fa-long-arrow-alt-right</v-icon>
      </div>
      <label for="progress" class="uppercase primary--text ma-0">{{ $t('ELEMENT-DETAIL.PROGRESS') }}</label>
      <v-spacer></v-spacer>
      <v-divider vertical class="mx-2"></v-divider>
      <element-details-config-button :el="el" config="show-progress"></element-details-config-button>
    </div>
    <div class="ml-6 pl-2 display-flex align-center">
      <v-progress-linear :class="{ pointer: ! isConsult }" :value="progress" color="successgreen" height="16" rounded class="mr-2" style="flex: 1 1 auto;"
                         @click="! isConsult && clickProgressBar($event)">
        <div v-show="progress > 0" :style="{ 'margin-right': `${100 - progress}%` }"
             class="white--text small display-flex align-center justify-center" style="height: 100%; transition: all .3s">
          {{ progress }}%
        </div>
      </v-progress-linear>
      <v-text-field v-if="! isConsult" id="progress" v-model.number="progress" type="number" min="0" max="100" step="10" suffix="%" hide-details
                    class="ml-2 mt-0 pt-0 mb-2" style="flex: 0 1 75px">
      </v-text-field>
    </div>

    <!-- PROCESS STEP -->
    <template v-if="! isConsult && availableProcessSteps.length">
      <div class="display-flex align-center mt-4">
        <div class="mr-2 text-center" style="flex: 0 0 24px;">
          <v-icon color="primary" small>fas fa-columns</v-icon>
        </div>
        <label for="processstep" class="uppercase primary--text ma-0">{{ $tc('KANBAN.STEP') }}</label>
        <span class="label-new ml-2">NEW</span>
      </div>
      <div class="ml-6 mb-4 pl-2 d-flex align-end">
        <v-select id="processstep" v-model="processStep" :items="availableProcessSteps" item-text="label" item-value="id"
                  clearable hide-details class="pt-0" style="flex: 0 0 calc(100% - 70px)">
        </v-select>
        <!-- next step button -->
        <v-btn v-if="processStepIndex < availableProcessSteps.length - 1" :title="$t('KANBAN.NEXT_STEP')" icon small class="ml-2"
               @click="processStep = availableProcessSteps[processStepIndex + 1].id">
          <v-icon small>fas fa-arrow-right</v-icon>
        </v-btn>
      </div>
    </template>
  </div>
</template>

<script>
  import ElementDetailsConfigButton from './partials/ElementDetailsConfigButton';

  export default {
    components: {
      ElementDetailsConfigButton,
    },
    props: {
      el: { type: Object, required: true },
    },
    data() {
      return {
      };
    },
    computed: {
      isConsult() { return this.el.isType('macro'); },
      progress: {
        get() {
          return parseInt(this.el.getProgress(), 10) || 0;
        },
        set(newVal) {
          this.el.setProgress(newVal);
        },
      },
      processStep: {
        get() {
          return this.el.getProcessStep();
        },
        set(newVal) {
          this.el.setProcessStep(newVal);
        },
      },
      availableProcessSteps() {
        return this.el.getPlanning().process.steps.filter(step => step.id);
      },
      processStepIndex() {
        return this.availableProcessSteps.findIndex(step => step.id === this.processStep);
      },
    },
    methods: {
      clickProgressBar(event) {
        const fullWidth = event.currentTarget.clientWidth;
        if (! fullWidth) return;
        this.el.setProgress(Math.min(Math.round(event.offsetX / fullWidth * 10) * 10, 100));
      },
    },
  };
</script>
